import { z } from '@harvestiq/zod';

export const syncAuth0UserRequestSchema = z.object({
  auth0UserDataToken: z.string(),
});
export type SyncAuth0UserRequest = z.infer<typeof syncAuth0UserRequestSchema>;

export const auth0UserDataTokenPayloadSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  email: z.string().email(),
  emailVerified: z.boolean(),
  picture: z.string().optional(),
});

// No response expected, simply 200 code with 'OK' string content
export const syncAuth0UserResponseSchema = z.literal('OK');
export type SyncAuth0UserResponse = z.infer<typeof syncAuth0UserResponseSchema>;
